import React, { useState } from 'react';
import Video from '../../videos/video.m4v';
import VideoPoster from '../../images/video_poster.jpg'
import { HeaderContainer, HeaderBg, HeaderVideo, HeaderContent, HeaderH1, HeaderP, HeaderBtnWrapper, ArrowForward, ArrowRight } from './HeaderElements';
import { Button } from '../ButtonElement';
const Header = () => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <HeaderContainer id="home">
            <HeaderBg>
                <HeaderVideo autoPlay loop muted src={ Video } type='video/m4v' defer preload poster={ VideoPoster } />
            </HeaderBg>
            <HeaderContent>
                <HeaderH1>Strona Promująca Stowarzyszenie Sądecki Elektryk</HeaderH1>
                <HeaderP>Zobacz czym się zajmuje</HeaderP>
                <HeaderBtnWrapper>
                    <Button smooth={true} duration={500} spy={true} exact="true" offset={-80} to='about' onMouseEnter={onHover} onMouseLeave={onHover}>Dowiedz się więcej {hover ? <ArrowForward /> : <ArrowRight />}</Button>
                </HeaderBtnWrapper>
            </HeaderContent>
        </HeaderContainer>
    )
}

export default Header
